// src/config/pagos.js
// ─────────────────────────────────────────────────────────────────────────────
// ¿El pago a través de FIXO está disponible para los usuarios?
//
// Los T&C vigentes dicen que el sistema de pagos todavía no está activo, y los
// pagos quedaron afuera de la prueba con los testers (decisión de Diego,
// 24-10-2026). Mientras sea así, la web no ofrece pagar ni muestra la pantalla
// de cobros del prestador: que los T&C sean verdad, en lugar de depender de que
// nadie toque el botón.
//
// AUSENTE = ESCONDIDO. Se activa con REACT_APP_PAGOS_ACTIVOS=true en el build
// (CRA la lee al compilar: cambiarla exige un deploy). Sólo 'true' activa.
//
// ⚠ Esto esconde la INTERFAZ. POST /payments/checkout sigue respondiendo a
// quien lo llame con un token válido: cerrarlo es backend (Pendientes,
// DEUDA-CHECKOUT-ABIERTO-CON-PAGOS-ESCONDIDOS).
// ─────────────────────────────────────────────────────────────────────────────

export const PAGOS_ACTIVOS = process.env.REACT_APP_PAGOS_ACTIVOS === 'true';
